import(/* webpackMode: "eager" */ "/codebuild/output/src3916303705/src/Hfcl_digital_2.0_web/app/[locale]/page.js");
